import { Seo } from "../components/portfolio/Seo";
import { Hero } from "../components/portfolio/Hero";
import { Ribbon } from "../components/portfolio/Ribbon";
import { AreaCards } from "../components/portfolio/AreaCards";
import { Credentials } from "../components/portfolio/Credentials";
import { Contact } from "../components/portfolio/Contact";

export default function Home() {
  return (
    <>
      <Seo
        title="Multi-Disciplinary Portfolio"
        description="Jessica Dannielle Johnson — Learning Experience Designer, ERP trainer, photographer, videographer, web & graphic designer, interior designer, and licensed REALTOR."
      />
      <Hero />
      <Ribbon />
      <AreaCards />
      <Credentials />
      <Contact />
    </>
  );
}
